import { Get, Post } from "@/src/api";
import { User } from "@/src/types/user";

export async function fetchUser(userId: string): Promise<User> {
  return Get(`/support/user/overview?userId=${userId}`);
}

export async function persistPayout(
  payoutId: number,
  mail: string | null,
): Promise<void> {
  await Post("/support/user/manual-payout", { payoutId, mail });
}

export async function resendEmail(payoutId: number): Promise<void> {
  await Post("/support/user/resend-tremendous-mail", { payoutId });
}

// Intentionally hardcodes livenessStatus: true — there is no client un-verify
// path, and adding one needs a server-side story first.
export async function verifyLiveness(userId: string): Promise<void> {
  await Post(`/support/user/${userId}/verify-liveness`, {
    livenessStatus: true,
  });
}
